import React from 'react';
import styles from '../history-controls.module.scss';

type HistoryDirection = 'undo' | 'redo';

type HistoryIconProps = {
  direction: HistoryDirection;
};

export const HistoryIcon = ({ direction }: HistoryIconProps): React.ReactElement => (
  <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" className={styles['history-icon']}>
    <g transform={direction === 'redo' ? 'translate(24 0) scale(-1 1)' : undefined}>
      <path d="M9 5 4 10l5 5M4 10h11a6 6 0 0 1 0 12h-2" />
    </g>
  </svg>
);
